var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlpine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m8.895 13.598-1.149 4.163h4.88L25.259 8h3.374l-3.374 9.76H31l-2.727 2.154h-3.517l-1.148 3.301h-3.374l1.077-3.301h-7.248l-4.45 3.301H5.593l4.45-3.301H1l7.895-6.316zm8.038 4.09 6.962-5.597-1.65 5.6h-5.312z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlpine);
export default __webpack_public_path__ + "static/media/ALPINE.508c51523e91b4a257aa49af3b7b5b92.svg";
export { ForwardRef as ReactComponent };